module.exports = __webpack_public_path__ + "static/media/bg-health-screening.2dc5ae4d.png";